module.exports = __webpack_public_path__ + "media/src/images/icon/heart-73078b2c9420f726e767bf7126929788.svg";